<div class="container text-red text-center">
    <mat-icon class="mb-2">error</mat-icon>
    {{ text }}
</div>